// AUTO-GENERATED by scripts/generate-accounts.cjs — DO NOT EDIT.
// Source: /home/claude-user/.claude/accounts/registry.json
// Regenerate via: npm run generate:accounts (or any build).

import type { Account } from './index';

export const GENERATED_ACCOUNTS: Account[] = [
  {
    "id": "auto",
    "label": "Auto (Best)",
    "color": "#22c55e"
  },
  {
    "id": "sahori",
    "label": "Sahori",
    "color": "#bb9af7",
    "provider": "claude"
  },
  {
    "id": "kurt",
    "label": "Kurt",
    "color": "#9ece6a",
    "provider": "claude"
  },
  {
    "id": "coach",
    "label": "Coach",
    "color": "#7dcfff",
    "provider": "claude"
  },
  {
    "id": "erk",
    "label": "Erk",
    "color": "#f7768e",
    "provider": "claude"
  },
  {
    "id": "local",
    "label": "Lokal",
    "color": "#e0af68"
  }
];
